/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BigCommercePalletBase
 */
export interface BigCommercePalletBase {
  /**
   *
   * @type {number}
   * @memberof BigCommercePalletBase
   */
  lengthInches: number;
  /**
   *
   * @type {number}
   * @memberof BigCommercePalletBase
   */
  widthInches: number;
}

/**
 * Check if a given object implements the BigCommercePalletBase interface.
 */
export function instanceOfBigCommercePalletBase(
  value: object,
): value is BigCommercePalletBase {
  if (!("lengthInches" in value) || value["lengthInches"] === undefined)
    return false;
  if (!("widthInches" in value) || value["widthInches"] === undefined)
    return false;
  return true;
}

export function BigCommercePalletBaseFromJSON(
  json: any,
): BigCommercePalletBase {
  return BigCommercePalletBaseFromJSONTyped(json, false);
}

export function BigCommercePalletBaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommercePalletBase {
  if (json == null) {
    return json;
  }
  return {
    lengthInches: json["lengthInches"],
    widthInches: json["widthInches"],
  };
}

export function BigCommercePalletBaseToJSON(json: any): BigCommercePalletBase {
  return BigCommercePalletBaseToJSONTyped(json, false);
}

export function BigCommercePalletBaseToJSONTyped(
  value?: BigCommercePalletBase | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lengthInches: value["lengthInches"],
    widthInches: value["widthInches"],
  };
}
